module.exports = __webpack_public_path__ + "assets/mobirise.d98d77ae.svg";